// src/pages/CookingClass.jsx
import React from "react";
import Footer from "../components/Footer";
import SubHeader from "../components/SubHeader";

function CookingClass() {
  return (
    <>
      <SubHeader />
      <main>
        <section className="page-header">
          <div className="page-header__bg"></div>
          <div className="container">
            <ul className="villoz-breadcrumb list-unstyled">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <span>Experiences</span>
              </li>
              <li>
                <span>Sri Lankan Cooking Classes</span>
              </li>
            </ul>
            <h2 className="page-header__title">Sri Lankan Cooking Classes</h2>
          </div>
        </section>

        <section className="destinations-details">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="destinations-details__image">
                  <img
                    src="/assets/images/activities/cookingclass/main.webp?v=20260924"
                    alt="Sri Lankan Cooking"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="destinations-details__content">
                  <h3 className="destinations-details__title">
                    Sri Lankan Cooking Classes
                  </h3>
                  <p className="destinations-details__text">
                    Join Suba, our talented homeowner and self-taught cook, for
                    a hands-on journey into the heart of Sri Lankan cuisine.
                    Suba’s cooking has always been the soul of Hanthana House,
                    where her meals have been the highlight of many guests’
                    stays with some even saying her food is the best they’ve
                    tasted in Sri Lanka!
                    <br />
                    <br />
                    In this interactive session, you’ll be given an introduction
                    to Sri Lankan culinary facts, learning how to prepare a
                    traditional Sri Lankan meal using time-honoured techniques
                    and perfectly balanced spices. From the moment you step into
                    the kitchen, Suba will guide you through every step, sharing
                    her secrets and tips to help you create authentic flavours.
                    But the experience doesn’t end there. You’ll also get to
                    enjoy the meal you’ve cooked, learning the art of eating
                    with your hands – a cherished Sri Lankan tradition that
                    deepens your connection to the food and the culture.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="gallery-three">
          <div className="container">
            <div
              className="gallery-three__carousel villoz-owl__carousel villoz-owl__carousel--basic-nav owl-carousel owl-theme"
              data-owl-options={`{"items":5,"margin":30,"loop":false,"smartSpeed":700,"nav":false,"navText":["<span class='fa fa-angle-left'></span>","<span class='fa fa-angle-right'></span>"],"dots":false,"autoplay":true,"responsive":{"0":{"items":1},"360":{"items":2,"margin":20},"575":{"items":3},"992":{"items":4},"1200":{"margin":42,"items":5}}}`}
            >
              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="/assets/images/activities/cookingclass/1.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="/assets/images/activities/cookingclass/1.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon"></span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="/assets/images/activities/cookingclass/2.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="/assets/images/activities/cookingclass/2.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon"></span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="/assets/images/activities/cookingclass/3.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="/assets/images/activities/cookingclass/3.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon"></span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="/assets/images/activities/cookingclass/4.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="/assets/images/activities/cookingclass/4.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon"></span>
                    </a>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="gallery-three__card">
                  <img
                    src="/assets/images/activities/cookingclass/5.webp?v=20260924"
                    alt=""
                  />
                  <div className="gallery-three__card__hover">
                    <a
                      href="/assets/images/activities/cookingclass/5.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default CookingClass;
